import React from "react";
import "./App.css";
import hondaLogo from "./assets/honda-logo.png";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={hondaLogo} className="App-logo" alt="logo" />
        <div className="App-alert">
          <p className="Title">Sistema em manutenção</p>
          <p className="Description">
            Desculpe o transtorno, no momento a plataforma encontra-se em
            manutenção.
          </p>
        </div>
        <p className="App-link">Previsão de Retorno: 24/08/2020 as 05h00</p>
      </header>
      <footer className="App-footer">
        <img
          src="https://cdn.ubik.com.br/logos/powered_ubk_white.png"
          alt="Ubik Assinatura"
        />
      </footer>
    </div>
  );
}

export default App;
